export default "https://cdn-static.gokick.com/assets/7e8bc23aa9277111cd73fa77d581d1f801b67d5a/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";